var _path, _mask, _g, _rect, _rect2, _path2, _path3, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconIdDoc = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5 65C50.4493 65 65 50.4493 65 32.5C65 14.5507 50.4493 0 32.5 0C14.5507 0 0 14.5507 0 32.5C0 50.4493 14.5507 65 32.5 65Z",
    fill: "#BCD9C9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 20,
    width: 43,
    height: 29
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0861 20.1725H52.6723V48.1897H10.0861V20.1725Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.1282 48.1897H12.6306C11.2251 48.1897 10.0861 46.9821 10.0861 45.4911V22.8712C10.0861 21.3807 11.2251 20.1725 12.6306 20.1725H50.1282C51.5333 20.1725 52.6723 21.3807 52.6723 22.8712V45.4911C52.6723 46.9821 51.5333 48.1897 50.1282 48.1897Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38.1033,
    y: 38.1035,
    width: 11.2069,
    height: 2.24138,
    rx: 1.12069,
    fill: "#727D79"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32.4998,
    y: 26.8966,
    width: 16.8103,
    height: 2.24138,
    rx: 1.12069,
    fill: "#727D79"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 32C23.6569 32 25 30.6569 25 29C25 27.3431 23.6569 26 22 26C20.3431 26 19 27.3431 19 29C19 30.6569 20.3431 32 22 32Z",
    stroke: "#FF8B22",
    strokeWidth: 1.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29 41C29 37.134 25.866 34 22 34C18.134 34 15 37.134 15 41",
    stroke: "#FF8B22",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.4998,
    y: 32.5,
    width: 16.8103,
    height: 2.24138,
    rx: 1.12069,
    fill: "#727D79"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.71533,
    y: 19.8018,
    width: 45.569,
    height: 28.7586,
    rx: 3.25,
    stroke: "#727D79",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconIdDoc);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-id-doc.35dfada163d065ef16a87f57773b87bd.svg";